import React, { useState, useEffect, useContext } from 'react'
import { Form, Descriptions, Divider, Tag, Alert, message, Spin, Button} from 'antd';
import {useFetch, useDiscord} from '@utils'
import moment from 'moment';
import { appContext } from '../AppContext';
import { getEventDate, getMyRegistration, getNPCCost, getRentCost, isSlOfEvent } from '../components/Registration/functions';
import { RegistrationForm } from '../components/Registration/RegistrationForm';
import PaymentInfoModal from '../components/Registration/PaymentInfoModal';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';


export default function RegistrationPage(){

    const urlParams = new URLSearchParams(window.location.search);
    const eventId = urlParams.get('id'); 


    const [doFetch, FetchOptions] = useFetch();
    const [appState, AppDispatch] = useContext(appContext);
    const [originalLarper, setOriginalLarper] = useState({});
    const [somethingChanged, setSomethingChanged] = useState(false)

    const [record, setEvent] = useState(undefined);
    const [isLoading, setIsLoading] = useState(true);
    const [isUpdating, setIsUpdating] = useState(false);

    const [myRegistraton, setMyRegistration] = useState(undefined);

    const isSl = isSlOfEvent(record?.story, appState)
    const [currentRegistrationType, setCurrentRegistrationType] = useState(isSl ? 3 : 1)

    const [isShowPaymentInfoModal, setIsShowPaymentInfoModal] = useState(false);
    const [sendDiscordUpdate] = useDiscord();

    const [form] = Form.useForm()
    form.setFieldsValue(record)

    useEffect(() => {
        refresh();
    }, //eslint-disable-next-line
    [] )

    function refresh() {
        doFetch("/api/event")
        .then((response) => dataLoaded(response.isSuccess, response.result))

        function dataLoaded(isSuccess, result) {
            if(isSuccess) {
                // eslint-disable-next-line
                const found = result.find(_ => _.id == eventId)
                setEvent(found);
                setIsLoading(false);
                return;
            }
            setEvent(undefined);
            setIsLoading(false);
            message.error('Could not find event')
        }
    }

    useEffect(() => {
        setOriginalLarper({
            name:appState.user.name,
            emailAddress:appState.user.emailAddress, 
            userRoles:appState.user.userRoles,
            isAdmin:appState.user.isAdmin,
            isSlOfStory:appState.isSlOfStory,
            emailConfirmed:appState.user.emailConfirmed,
            id:appState.user.id,
            emailNotifications:appState.user.emailNotifications,
            privateInfo:appState.user.privateInfo
        })
    }, // eslint-disable-next-line
    [appState.user])

    function refreshLarper() {

        const url = `/api/Account/GetCurrentUser`;

        doFetch(url)
            .then((response) => {
                if(response.isSuccess) {
                    AppDispatch({ type: "LOGIN", payload: response.result })
                }
            })
    }

    useEffect(() => {

        if(!record) {
            return;
        }
        const myRegistration = getMyRegistration(record.registrations, appState.user.id)
        setMyRegistration(myRegistration)
        form.setFieldsValue(myRegistration)
        if(myRegistration !== null && myRegistration !== undefined) {
            setCurrentRegistrationType(myRegistration.registrationType)
        }

    }, //eslint-disable-next-line
    [form, record])

    if(isLoading) {
        return <Spin />
    }

    // eslint-disable-next-line
    if(appState.storyId != record.storyId) {
        AppDispatch({ type: "SETSTORYID", payload: {storyId:record.storyId, storyName:record.story} })
        return <Spin />
    }

    return (
            <>
                {myRegistraton != null && !myRegistraton?.paidConfirmation && <Alert
                    message="You have registerd, but not paid yet."
                    type="warning"
                    showIcon
                />}
                <br />
                <h1>{record.story} {record.sequenceNumber}</h1>
                <Descriptions bordered>
                    <Descriptions.Item label="Date"> 
                        {getEventDate(record)}
                    </Descriptions.Item>
                    <Descriptions.Item label="Location"> 
                        <>

                            <a target='_blank' rel="noopener noreferrer" href={record.locationModel?.link}>
                                {record.locationModel?.name}
                            </a>
                            <br />
                            <a target='_blank' rel="noopener noreferrer" href={record.locationModel?.linkMaps}>
                                {record.locationModel?.adress}
                            </a>
                            <br />
                            <br />
                            {record.locationModel?.description}
                        </>
                    </Descriptions.Item>
                    {/* {getSkillPointsDescription()} */}
                    <Descriptions.Item label="Cost" >

                        {myRegistraton?.paidConfirmation ? <Tag color="success">Paid</Tag> :
                        <>
                            Does not include possible weapon rent
                            <br />
                            Before {moment(record.costEndDate).add(-1, 'days').format('DD MMMM')}
                            <br />
                            Player: €{record.costStart}
                            <br />
                            NPC: €{getNPCCost(record.story, record.costStart)}
                            <br />
                            After {moment(record.costEndDate).format('DD MMMM')}
                            <br />
                            Player: €{record.costEnd}
                            <br />
                            NPC: €{getNPCCost(record.story, record.costEnd)}
                            <br />
                            <Button onClick={() => setIsShowPaymentInfoModal(true)}>Payment information</Button>
                        </>}
                    </Descriptions.Item>
                    {/* {appState.isSlOfStory && <Descriptions.Item label="Player" >
                        {newCharacter.larper?.name}
                    </Descriptions.Item>} */}
                </Descriptions>

                <Divider/>
                <RegistrationForm 
                    record={record}
                    onUpdate={onUpdate}
                    myRegistraton={myRegistraton}
                    somethingChanged={somethingChanged}
                    setSomethingChanged={setSomethingChanged}
                    currentRegistrationType={currentRegistrationType}
                    setCurrentRegistrationType={setCurrentRegistrationType}
                    isSl={isSl}
                    getRentCost={getRentCost}
                    originalLarper={originalLarper}
                    refreshLarper={refreshLarper}
                    isUpdating={isUpdating}
                />
                {isShowPaymentInfoModal && <PaymentInfoModal 
                    isModalVisible={isShowPaymentInfoModal}
                    setIsModalVisible={setIsShowPaymentInfoModal}
                    eventName={`${record.story} ${record.sequenceNumber}`}
                    larperName={appState.user?.name}
                />}
            </>
    )

    function onUpdate(values)
    {
        setIsUpdating(true);
        const url = `/api/Registration`;

        const body = {
            // ...record,
            id: myRegistraton?.id,
            larperId: appState.user.id,
            eventId: record.id,
            registrationType: currentRegistrationType,
            sleep: values.sleep,
            hire: currentRegistrationType !== 1 ? null : values.hire,
            notes: values.notes,
            slNotes: values.slNotes,
            paid: myRegistraton?.paid,
            paidConfirmation: myRegistraton?.paidConfirmation,
            character: values.characterId === undefined ? null : {
                id: values.characterId
            } 
        }

        doFetch(url, FetchOptions.POST, body)
            .then((response) => onAddInventoryLoaded(response.isSuccess))

        function onAddInventoryLoaded(isSuccess) {
            if(isSuccess) {
                refresh()
                setSomethingChanged(false)
                message.success(myRegistraton === null ? "You have registerd": "Registration updated")
                let registrationType = "SL";
                switch(currentRegistrationType) {
                    case 1: 
                        registrationType = "Player";
                        break;
                    case 2: 
                        registrationType = "NPC";
                        break;
                    case 3: 
                        registrationType = "SL";
                        break;
                    default:
                        registrationType = "Other";
                        break;
                }
                if(myRegistraton === null) {
                    sendDiscordUpdate(`${appState.user?.name} registered for event ${record.story} ${record.sequenceNumber} as a ${registrationType}`, true)
                }
                else {
                    sendDiscordUpdate(`${appState.user?.name} updated his registration for event ${record.story} ${record.sequenceNumber} type = ${registrationType}`, true)
                }

                setIsUpdating(false);
                return;
            } 

            setIsUpdating(false);
            message.error('Could not register');
        }
    }
}